import { Box, Button, Card, CardContent, Chip, Collapse, IconButton, Typography } from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { IssueAttachments } from './IssueAttachments'
import { RedactedSensorField } from '../demo/RedactedSensorField'
import { STATUS_COLORS, PRIORITY_COLORS } from './issues-constants'

export function IssueCard({ issue, expanded, onToggleExpand, onClose, getAttachmentUrl, canClose }) {
	return (
		<Card>
			<CardContent>
				<Box display="flex" justifyContent="space-between" alignItems="flex-start">
					<Box flex={1}>
						<Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mb={1}>
							<Typography variant="h6">{issue.title}</Typography>
							<Chip
								label={issue.status.replace('_', ' ')}
								color={STATUS_COLORS[issue.status] || 'default'}
								size="small"
							/>
							<Chip
								label={issue.priority}
								color={PRIORITY_COLORS[issue.priority] || 'default'}
								size="small"
							/>
							{issue.sensor_id && (
								<RedactedSensorField inline minWidth={88} minHeight={24} sx={{ verticalAlign: 'middle' }}>
									<Chip label={issue.sensor_id} variant="outlined" size="small" />
								</RedactedSensorField>
							)}
						</Box>
						<Typography variant="body2" color="text.secondary">
							{new Date(issue.created_at).toLocaleString()}
							{issue.issue_attachments?.length > 0 && (
								<> · {issue.issue_attachments.length} attachment(s)</>
							)}
						</Typography>
					</Box>
					<Box display="flex" alignItems="center" gap={0.5}>
						{canClose && (
							<Button size="small" variant="outlined" color="inherit" onClick={onClose}>
								Close
							</Button>
						)}
						<IconButton onClick={onToggleExpand} size="small">
							{expanded ? <ExpandLess /> : <ExpandMore />}
						</IconButton>
					</Box>
				</Box>

				<Collapse in={expanded}>
					<Box mt={2} pt={2} borderTop={1} borderColor="divider">
						{issue.description && (
							<Typography variant="body2" sx={{ mb: 2, whiteSpace: 'pre-wrap' }}>
								{issue.description}
							</Typography>
						)}
						{issue.issue_attachments?.length > 0 && (
							<Box>
								<Typography variant="subtitle2" gutterBottom>
									Attachments
								</Typography>
								<IssueAttachments
									attachments={issue.issue_attachments}
									getAttachmentUrl={getAttachmentUrl}
								/>
							</Box>
						)}
					</Box>
				</Collapse>
			</CardContent>
		</Card>
	)
}
